/* tslint:disable:max-line-length */
import React from 'react'

interface Props {
    width?: number
    height?: number,
    fill?: string,
    stroke?: string
}

interface State {}

export default class PlusIcon extends React.Component<Props, State> {

    public render() {

        let {
            fill = '#FFF',
            stroke,
            width = 12,
            height = 12
        } = this.props

        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
                <path stroke={stroke} fill={fill} fillRule="evenodd" d="M12 4.367H7.633V0H4.367v4.367H0v3.266h4.367V12h3.266V7.633H12z"/>
            </svg>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_assets/icons/Plus.tsx